import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'for_wrkrs_seeking_to_end_their_employment_how_many_days_of_noti'

export const dataPointDefinition = {
  retracedId: 'for_wrkrs_seeking_to_end_their_employment_how_many_days_of_noti',
  name: 'For workers seeking to end their employment, how many days of notice are required by the facility?',
  description:
    'There may be different notice periods for different types of workers. Please enter the highest number of days of notice applicable at your facility. ',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fl-10',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17730,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
